import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, Layout, BarChart3, Lock, Clock, Layers } from 'lucide-react';
export function ProblemSection() {
  const userIssues = [{
    icon: <Layout className="w-5 h-5" data-id="element-212" />,
    text: 'Outdated UX patterns'
  }, {
    icon: <Layers className="w-5 h-5" data-id="element-213" />,
    text: 'Inconsistent experience across offers'
  }];
  const techIssues = [{
    icon: <Lock className="w-5 h-5" data-id="element-214" />,
    text: 'AEM structure limits layout flexibility'
  }, {
    icon: <Layout className="w-5 h-5" data-id="element-215" />,
    text: 'Design changes require dev cycles'
  }, {
    icon: <Clock className="w-5 h-5" data-id="element-216" />,
    text: 'Slow campaign turnaround'
  }];
  return <section className="h-full flex items-center py-8 px-4 sm:px-6 lg:px-8 bg-gray-50/50 overflow-y-auto lg:overflow-hidden" data-id="element-217">
      <div className="max-w-6xl mx-auto w-full" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mb-10" data-id="element-219">
          <span className="text-xs font-bold tracking-widest text-[#80BC41] uppercase mb-3 block" data-id="element-220">
            01 — The Problem
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a1a1a] font-heading" data-id="element-221">
            The current system limits performance
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-10" data-id="element-222">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: 'easeOut'
        }} className="bg-white p-6 md:p-8 rounded-xl border border-gray-100 shadow-sm" data-id="element-223">
            <h3 className="text-base font-bold text-[#1a1a1a] mb-6 flex items-center gap-3" data-id="element-224">
              <div className="w-9 h-9 rounded-lg bg-red-50 flex items-center justify-center text-[#EB0A1E]" data-id="element-225">
                <TrendingDown className="w-4 h-4" data-id="element-226" />
              </div>
              User Experience
            </h3>
            <ul className="space-y-4" data-id="element-227">
              {userIssues.map((issue, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-228">
                  <div className="text-gray-400 mt-0.5" data-id="element-229">{issue.icon}</div>
                  <span className="text-gray-700 font-medium text-sm" data-id="element-230">
                    {issue.text}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2,
          ease: 'easeOut'
        }} className="bg-white p-6 md:p-8 rounded-xl border border-gray-100 shadow-sm" data-id="element-231">
            <h3 className="text-base font-bold text-[#1a1a1a] mb-6 flex items-center gap-3" data-id="element-232">
              <div className="w-9 h-9 rounded-lg bg-red-50 flex items-center justify-center text-[#EB0A1E]" data-id="element-233">
                <Lock className="w-4 h-4" data-id="element-234" />
              </div>
              Technical Constraints
            </h3>
            <ul className="space-y-4" data-id="element-235">
              {techIssues.map((issue, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-236">
                  <div className="text-gray-400 mt-0.5" data-id="element-237">{issue.icon}</div>
                  <span className="text-gray-700 font-medium text-sm" data-id="element-238">
                    {issue.text}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}